import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";

const Image = ({ imagePath, small, style }) => {
  console.log(imagePath);
  return (
    <div style={{ position: "relative" }}>
      <Avatar
        style={{
          width: small ? 50 : 150,
          height: small ? 50 : 150,
          borderRadius: 5,
          marginRight: small ? 0 : 10,
          marginBottom: small ? 0 : 5,
          ...style,
          cursor: "pointer",
        }}
        src={
          imagePath || "https://via.placeholder.com/150?text=Choose an image"
        }
      />
      <EditIcon
        style={{ position: "absolute", left: 5, top: 5, cursor: "pointer" }}
        htmlColor="white"
      />
    </div>
  );
};

Image.propTypes = {
  imagePath: PropTypes.string,
  small: PropTypes.bool,
};

export default React.memo(Image);
